/**
 * @jsx React.DOM
 */
'use strict';

var React = require('react');
var $ = window.$;

var TimeSlider = React.createClass({displayName: 'TimeSlider',
  componentDidMount: function() {
    $('.Slider').slider();
  },
  render: function() {
    return (
      React.DOM.div({className: "react-time-slider"}, 
        TimeSliderTitle(null), 
        React.DOM.div({className: "Slider"})
      )
    );
  }
});

var TimeSliderTitle = React.createClass({displayName: 'TimeSliderTitle',
  render: function() {
    return (
      React.DOM.div({className: "time-slider-title"}, 
        React.DOM.em(null, "from "), 
        React.DOM.strong(null, 
          React.DOM.div({className: "from"}, "Jan 2014")
        ), 
        React.DOM.em(null, " to "), 
        React.DOM.strong(null, 
          React.DOM.div({className: "to"}, "Dec 2014")
        )
      )
    );
  }
});

module.exports = TimeSlider;
